<template>
  <div>
    <header class="vff-header" style="background-color:rgba(88,156,235, 0.8)">
      <div class="f-container">
        <span style="font-size:20pt;color:#000">{{quizzer.title}}</span>
        <!-- Add custom logo here -->
      </div>
    </header>
    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-on:submit="onQuizSubmit"
      v-on:timer="onTimer"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="false"
      v-bind:timer="false"
      timer-start-step="q-1"
    >
    
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
        <p>
          <span class="fh2">Quiz Complete!</span>
          <span v-if="!submitted" class="f-section-text">
            Review your answers or press Calculate score to see your result.
          </span>
        </p>
      </template>

      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button 
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Press to submit"
          >
            <span>Calculate score</span>
          </button>
          <a class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)">
          </a>
        </div>

        <p class="" v-if="submitted && score < quizzer.minimum_correct_answers_to_pass">Result: Fail.<br> You scored {{ quiz_score }}% on the quiz ({{score}} out of {{ total }}). 
          <br>The minimum number of correct answers to pass is: {{quizzer.minimum_correct_answers_to_pass}}
          <br><span class="text-success" v-if="submitted && time && score < quizzer.minimum_correct_answers_to_pass">Your time to complete: {{ formattedTime }}</span>
            <br><a onclick="window.location.reload(false)" class="btn-flat">Click here if would you like to try again.</a>
        </p>
        <p class="text-success" v-if="submitted && score >= quizzer.minimum_correct_answers_to_pass">Result: You Passed!<br>Congratuations! You scored {{ quiz_score }}% on the quiz ({{score}} out of {{ total }}).
                  <br>The minimum number of correct answers to pass is: {{quizzer.minimum_correct_answers_to_pass}}</p>
                  <br><span class="text-success" v-if="submitted && time && score >= quizzer.minimum_correct_answers_to_pass">Your time to complete: {{ formattedTime }}</span>
        </p>

        <div class="container" v-if="submitted && quiz_score>=0">
            <div class="row">
                <div class="col s12">
                    <ul class="collapsible popout">
                        <li v-for="(item, index) in saver" :key="'idx-'+ index" >
                            <div class="collapsible-header" style="color: #000;" v-if="item.result=='correct'"><i class="material-icons" style="color:green">check</i>{{item.question}}</div>
                            <div class="collapsible-header text-success" style="color: red;" v-if="item.result=='incorrect'"><i class="material-icons">clear</i>{{item.question}}</div>
                            <div class="collapsible-body">
                                You answered: {{getFormattedAnswer(item.answer)}}<br>
                                <span v-if="item.result=='incorrect'">Correct answer: {{getFormattedAnswer(item.correct_answer.answers)}}</span>
                                <span v-if="item.correct_answer.explanation && item.correct_answer.explanation!=''"><br><br>{{item.correct_answer.explanation}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
  import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LinkOption, LanguageModel } from '@ditdot-dev/vue-flow-form'
  import GqlV2Query from "@/plugins/gqlV2"
  export default {
    name: 'fyiioquiz',
    props: ['quizzer'],
    components: {
      FlowForm
    },
    mounted() {
        this.name = localStorage.getItem("name") || '';
        this.email = localStorage.getItem("email") || '';
    },
    data() {
      return {
        flowformx: undefined,
        email: '',
        name: '', 
        pass_result:false,
        saver: {},
        formSubmitted: false,
        completed: false,
        score: 0,  //counter of correct answers
        quiz_score: 0, //percentage of correct answers
        total: this.quizzer.questions.length, 
        time: 0,
        formattedTime: '',
        answers: this.getAnswers(),
        oldanswers: {
          html_1: ['2', '3'], 
          html_2: 'false', 
          html_3: '2', 
          html_4: ['3', '4'],  
          ux_1: ['1', '2', '4'], 
          ux_2: 'false', 
          ux_3: '4', 
          ux_4: 'true', 
        },
        language: new LanguageModel(),
        // Create question list with QuestionModel instances
        questions:this.getQuestions(),
        questionsOld: [      
          new QuestionModel({
            id: 'start',
            tagline: '8 questions',
            title: 'How much do you know about forms?',
            content: 'Test how well you know HTML forms in the first quiz section.',
            type: QuestionType.SectionBreak,
            required: true,
          }),
          new QuestionModel({
            id: 'html_2',
            title: '<label> is associated with <input> using the "name" attribute.',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            required: true,
            multiple: false,
             options: [
              new ChoiceOption({
                label: 'True', 
                value: 'true'
              }),
              new ChoiceOption({
                label: 'False', 
                value: 'false'
              })
            ]
          }),
        ]
      }
    },
    computed: {
      submitted: function () {
        if(this.flowformx){
          return this.formSubmitted
        }else{
          return false
        }

      }
    },
    methods: {
    getFormattedAnswer(itemer){
        if(Array.isArray(itemer)){
            //slice creates a shallow copy so a mututation in sort doesn't trigger a re-render loop
            return itemer.slice().sort().join(", ");
        }else{
            return itemer;
        }
    },
    getQuizIntro(){
        let self=this;
        let intro=new QuestionModel({
            id: 'start',
            tagline: `${self.quizzer.questions.length} questions`,
            title: `${self.quizzer.title}`,
            content: `${self.quizzer.description}`,
            type: QuestionType.SectionBreak,
            required: true,
        })
        return intro
    },
    getUserInfo(collect_info_required){
        let self=this;
        let userInfo=[];
        let name = new QuestionModel({
            id: 'name',
            tagline: 'Hi! Thanks for taking the quiz, before we get started...',
            title: 'What is your name?',
            type: QuestionType.Text,
            required: collect_info_required,
            //answer:'bubba',
            placeholder: 'Start typing here...'
          });
          if(localStorage.getItem("name")!=null){
            name.answer=localStorage.getItem("name");
          }

          userInfo.push(name);
          let email=new QuestionModel({
            id: 'email',
            tagline: "In order to get credit for the quiz",
            title: 'Please enter your email',
            type: QuestionType.Email,
            required: collect_info_required,
            placeholder: 'Start typing here...'
          });
          if(localStorage.getItem("email")!=null){
            email.answer=localStorage.getItem("email");
          }
          userInfo.push(email);
        return userInfo
    },
    getAnswers(){
        let self=this;
        let returner={}
        this.quizzer.questions.forEach((question, idx) => {
            let qid=`q-${idx}`
            let answerer={}
            answerer['answers']=question.correct_answers['correct_answers']
            answerer['explanation']=question.explanation;
            returner[qid]=answerer
        })
        return returner
    },
    getQuestions(){
        let self=this;
        let returner=[];
        returner.push(self.getQuizIntro())
        if(self.quizzer.collect_user_information && self.quizzer.collect_user_information!="do_not_collect"){
            let collect_info_required=(self.quizzer.collect_user_information=="required"?true:false)
            returner.push(...self.getUserInfo(collect_info_required))
        }
        let qs=this.quizzer.questions;
        
        for(let i=0;i<qs.length;i++){
          let multiple_answer_mode=false;
          if(qs[i].question_type=="MULTIPLE_CHOICE"){
              multiple_answer_mode=true;
          }
          let qid=`q-${i}`
          
          let rq=new QuestionModel({
            id:qid,
            title: qs[i].question,
            type: QuestionType.MultipleChoice,
            required:true,
            multiple: multiple_answer_mode,
            options: self.getOptions(qs[i].choices)
          })
          returner.push(rq);
        }
        //console.log(this.quizzer.questions)
        return returner
      },
      getOptions(choicesJSON){
        let choices=choicesJSON['choices']
        let holdChoices=[]
        choices.forEach(choice => {
            let holdChoice=new ChoiceOption({
                label: choice,
                value: choice
            })
            holdChoices.push(holdChoice);
            
        });
        return holdChoices;
      },
      /* eslint-disable-next-line no-unused-vars */
      onComplete(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
        this.completed = completed
      },
      arrayEquals(a, b) {
        if(Array.isArray(a) && Array.isArray(b)){
            a.sort();
            b.sort();
            return a.length === b.length && a.every((val, index) => val === b[index])
        } else{
            return false
        }
      },
      calculateScore() {
        this.questions.forEach(question => {
          let process_question=true
          
          if (question.type==QuestionType.Email){
              this.email=question.answer
              //this.saver['email']=question.answer
              process_question=false
          }
          if (question.id=="name"){
              this.name=question.answer
              //this.saver['name']=question.answer
              process_question=false
          }
          if (question.type !== QuestionType.SectionBreak && process_question) {
            this.saver[question.id]={}
            let answer = question.answer //these are the the answers the user provided
            this.saver[question.id].question=question.title
            this.saver[question.id].answer=answer
            this.saver[question.id].correct_answer=this.answers[question.id]

            if (typeof answer === 'object') {
              answer.sort((a, b) => a - b)
              if (this.arrayEquals(answer, this.answers[question.id].answers)) {    //this.answers[question.id] also contains the explanation
                this.score++
                this.saver[question.id].result="correct"
              }else{
                this.saver[question.id].result="incorrect"
              }
            }else if (answer == this.answers[question.id].answers) {
                    this.score++
                    this.saver[question.id].result="correct"
                }else{
                    this.saver[question.id].result="incorrect"
                }
          }
        })
        this.quiz_score=Math.floor((this.score/this.total) * 100)
        if(this.score>=this.quizzer.minimum_correct_answers_to_pass){
            this.pass_result=true
        }
        //initialize the results section
        
      }, 
      onQuizSubmit() {
        this.onSendData()
      },
      onSendData() {
          let self=this;
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform.submitted = true
        this.flowformx=this.$refs.flowform
        this.formSubmitted = true
        this.calculateScore()
        localStorage.setItem("name", self.name);
        localStorage.setItem("email", self.email);
        let variables = {
          quiz_id: self.quizzer.id, 
          name: self.name,
          email: self.email,
          answers:self.saver,
          score:self.quiz_score,
          result:self.pass_result
        };
        GqlV2Query.insertQuizResult(variables, (err, result) => {
          if (err) {
            this.error = err;
            
          } else {
            $(".collapsible").collapsible()
          }
        });

      },
      onTimer(time, formattedTime) {
        this.time = formattedTime
        this.formattedTime = formattedTime
      }
    },
  }
</script>

<style lang="css">
   @import '@ditdot-dev/vue-flow-form/dist/vue-flow-form.css';
 /*  @import '@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-purple.css';*/
  /* Import one of the Vue Flow Form CSS themes (optional) */
   @import '../../static/css/fyiio-flow-form-theme.css'; 

</style>


// WEBPACK FOOTER //
// src/containers/Quiz.vue